import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RedirectGuidanceService {
  /**
   * 別タブでPOST送信する
   * @param url 遷移先URL
   * @param params POSTパラメータ
   */
  post(url: string, params: object): void {
    const form = document.createElement('form');
    form.method = 'POST';
    form.target = '_blank';
    form.action = url;

    form.onformdata = (formDataEvent: FormDataEvent) => {
      const formData = formDataEvent.formData;
      Object.entries(params).forEach(([key, value]) => formData.set(key, value));
    };

    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
    form.onformdata = null;
  }

  /**
   * ANAアプリ用のPOST送信
   * @param url 遷移先URL
   * @param params POSTパラメータ
   */
  anaAplPost(url: string, params: object): void {
    const form = document.createElement('form');
    form.method = 'POST';
    form.target = '_self';
    form.action = url;

    Object.entries(params).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
  }
}
